import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from '../../../../core/services/language.service';
import { ExamGroup } from '../../../models/entities/exam-group.entity';
import { ModalService } from '../../../../core/services/modal.service';
import { HttpExamGroupService } from '../../../../core/services/http/http-exam-group.service';
import { ExamGroupStudentsRankingQueryData } from '../../../models/payloads/exam.payload';
import { finalize } from 'rxjs';
import { ExamGroupSession } from '../../../models/entities/exam-group-session.entity';

@Component({
  selector: 'app-multirank-card',
  templateUrl: './multirank-card.component.html',
  styleUrls: ['./multirank-card.component.scss'],
})
export class MultirankCardComponent implements OnInit {
  @Input() examGroup: ExamGroup;
  @Input() index: number;
  @Input() type: 'dashboard' | 'ranking-list';
  @Output() examGroupUpdated = new EventEmitter<ExamGroup>();

  color: string;

  loadingStudentRankings = false;

  constructor(
    public languageService: LanguageService,
    public modalService: ModalService,
    private httpExamGroupService: HttpExamGroupService
  ) {}

  ngOnInit() {
    if (this.type === 'dashboard') {
      if (this.index % 3 === 0) {
        this.color = 'black';
      } else if (this.index % 3 === 1) {
        this.color = 'purple';
      } else if (this.index % 3 === 2) {
        this.color = 'green';
      }
    } else {
      this.color = 'yellow';
    }

    if (this.examGroup && this.type === 'dashboard') {
      this.listStudentRankings();
    }
  }

  listStudentRankings() {
    this.loadingStudentRankings = true;
    this.httpExamGroupService
      .listStudentsRanking(
        this.examGroup.id,
        new ExamGroupStudentsRankingQueryData({ perPage: 10, page: 1 })
      )
      .pipe(
        finalize(() => {
          this.loadingStudentRankings = false;
        })
      )
      .subscribe((res) => {
        this.examGroup.examGroupSessions = res['hydra:member'].map(
          (elt) => new ExamGroupSession(elt)
        );
        this.examGroupUpdated.emit(this.examGroup);
      });
  }

  get multirankUrl() {
    if (this.examGroup) {
      return ['/app/multi-ranking/ranking', this.examGroup.id];
    } else {
      return [];
    }
  }
}
